// @core/api/endpoints/calendar/list_event_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventTemplatesResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List event templates
 * Returns all event templates available in the product including personal and shared templates.
 */
export async function ListEventTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEventTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/event-templates`;
  const requestOptions = options;
  return client.get<ListEventTemplatesResponse>(requestPath, { ...requestOptions, params });
}
